import type Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { LearningModes } from "../types";

const learningModeIcon: Record<string, keyof typeof Icon.glyphMap> = {
	flip: "cards-outline",
	quiz: "format-list-checks",
	match: "checkerboard",
	questionSet: "format-list-checks",
	simulations: "call-split",
	questions: "order-bool-descending",
	essays: "file-document-edit-outline",
};

const getLearningModes = (
	_numFlashcards: number,
	numQuestions: number,
	numEssays?: number,
) => [
	{
		title: "Questions",
		icon: learningModeIcon.questions,
		value: LearningModes.questions,
		disabled: !numQuestions,
		count: numQuestions,
	},
	...(numEssays
		? [
				{
					title: "Essays",
					icon: learningModeIcon.essays,
					value: LearningModes.essays,
					disabled: !numEssays,
					count: numEssays,
				},
			]
		: []),
];

export { getLearningModes };
